import React, { FunctionComponent } from 'react';

import { useInverseThemeClassName } from '@yandex-360/orb-components/dist/components/Theme/useInverseThemeClassName';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { getNotifications } from '../../selectors';
import { NotificationsList } from '../notifications-list';
import styles from './styles.css';

export const PSNotifications: FunctionComponent = () => {
    const notifications = useSelector(getNotifications);
    // TODO: Выпилить после переезда на SnackBar, он инвертирует тему сам
    const inverseThemeClassName = useInverseThemeClassName();
    const { pathname } = useLocation();
    const isConferencesHistory = pathname.startsWith('/conferences-history');
    if (!notifications.length) {
        return null;
    }

    return (
        <>
            <div className={cn(styles.Notifications, inverseThemeClassName)}>
                <NotificationsList
                    notifications={notifications.filter((notification) => !notification.meta?.bottomGroup)}
                />
            </div>
            <div
                className={cn(styles.Notifications, styles.BottomGroup, inverseThemeClassName, {
                    [styles.conferencesHistory]: isConferencesHistory,
                })}
            >
                <NotificationsList
                    notifications={notifications.filter((notification) => notification.meta?.bottomGroup)}
                />
            </div>
        </>
    );
};
